import useLocalStorageState from 'use-local-storage-state'
import JwtDecode from 'jwt-decode'
import {useMemo} from 'react'

/**
 * @typedef DecodedToken
 * @type {object}
 * @property {string} role - "user"
 * @property {string} scp - scope (admin or user)
 * @property {string} sub - profile ID
 * @property {number} exp - expires at
 */

/**
 * @returns {{authToken: string | undefined, setAuthToken: UpdateState<string | undefined>, decoded: DecodedToken, isExpired: boolean, role: string | undefined, profileId: string | undefined}}
 */
const useAuthToken = () => {
  const [authToken, setAuthToken] = useLocalStorageState(`explus-app-auth-token`)
  /** @type {DecodedToken} */
  const decoded = useMemo(() => (authToken ? JwtDecode(authToken) : null), [authToken])
  const isExpired = useMemo(() => decoded?.exp * 1000 < new Date().getTime(), [decoded])
  const role = decoded?.role || 'user'
  return {
    authToken,
    setAuthToken,
    decoded,
    isExpired,
    role,
    profileId: decoded?.sub,
  }
}

export default useAuthToken
